const casdoorConfig = (type: any) => {
    let appName = process.env.NEXT_PUBLIC_CASDOOR_APP || "";
    let clientId = process.env.NEXT_PUBLIC_CASDOOR_CLIENT_ID || "";

    if (type === "connect_social") {
        appName = process.env.NEXT_PUBLIC_CASDOOR_APP_CONNECT_SOCIAL || "";
        clientId = process.env.NEXT_PUBLIC_CASDOOR_CLIENT_ID_CONNECT_SOCIAL || "";
    } else if (type === "email_authen") {
        appName = process.env.NEXT_PUBLIC_CASDOOR_APP_EMAIL_BACKUP || "";
        clientId = process.env.NEXT_PUBLIC_CASDOOR_CLIENT_ID_EMAIL_BACKUP || "";
    }

    return {
        serverUrl: process.env.NEXT_PUBLIC_CASDOOR_SERVER_URL || "",
        organizationName: process.env.NEXT_PUBLIC_CASDOOR_ORG || "",
        appName,
        clientId,
        redirectPath: "/callback",
    };
};

export default casdoorConfig;
